'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface SuccessMessageProps {
  onClose: () => void;
}

const SuccessMessage = ({ onClose }: SuccessMessageProps) => {
  return (
    <div className="fixed inset-0 z-1020 flex items-center justify-center p-4 bg-foreground/50 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-elevation-xl max-w-md w-full p-8 space-y-6 animate-in fade-in zoom-in duration-300">
        <div className="flex flex-col items-center space-y-4">
          <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center">
            <Icon name="CheckCircleIcon" variant="solid" size={40} className="text-success" />
          </div>
          
          <h2 className="text-2xl font-heading font-semibold text-foreground text-center">
            ¡Retroalimentación Enviada!
          </h2>
          
          <p className="text-center text-muted-foreground">
            Gracias por compartir tu experiencia con nosotros. Tu retroalimentación nos ayuda a mejorar LynMet y priorizar mejor lo que sigue.
          </p>
        </div>

        <div className="bg-muted rounded-md p-4 space-y-2">
          <div className="flex items-start space-x-3">
            <Icon name="InformationCircleIcon" size={20} className="text-primary mt-0.5 flex-shrink-0" />
            <div className="space-y-1">
              <p className="caption font-medium text-foreground">
                ¿Qué sigue?
              </p>
              <p className="caption text-muted-foreground">
                Nuestro equipo revisará tu mensaje pronto. Si dejaste tu correo y pediste seguimiento, te responderemos desde contacto@lynmet.com.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-3">
          <Link
            href="/user-dashboard"
            className="w-full sm:flex-1 inline-flex items-center justify-center space-x-2 px-6 py-3 bg-primary text-primary-foreground rounded-md font-medium hover:bg-primary/90 active:scale-97 transition-smooth shadow-elevation-sm hover:shadow-elevation-md"
          >
            <Icon name="HomeIcon" size={20} />
            <span>Ir al Dashboard</span>
          </Link>
          
          <button
            onClick={onClose}
            className="w-full sm:flex-1 inline-flex items-center justify-center space-x-2 px-6 py-3 bg-secondary text-secondary-foreground rounded-md font-medium hover:bg-secondary/90 active:scale-97 transition-smooth shadow-elevation-sm hover:shadow-elevation-md"
          >
            <Icon name="PlusCircleIcon" size={20} />
            <span>Nueva Retroalimentación</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessMessage;
